/**
 * Keeps a password manager out of a field that holds no credential.
 *
 * 1Password, LastPass and Dashlane all guess at forms rather than being told
 * about them, and a short form with a name field reads to that guess as a
 * sign-up. The badge they inject then sits inside the input, over the text
 * being typed, and their dropdown covers the field below it.
 *
 * `autoComplete="off"` alone does not do it — the managers ignore it on
 * purpose, because sites used it to block the browser's own saved logins. Each
 * one instead honours a vendor attribute, so opting out means naming all of
 * them.
 *
 * Only for fields that are genuinely not credentials. Sign-in keeps its
 * autofill: that is the one form where the manager is doing its job.
 */
export const noAutofill = {
  autoComplete: 'off',
  'data-1p-ignore': true,
  'data-lpignore': true,
  'data-form-type': 'other',
} as const;
